
(function(){    
    const $wrappers = document.querySelectorAll('.images-features__wrapper');

    function setupSlicks($wrapper) {
      let $cells = $wrapper.querySelectorAll('.image-features-grid__item');
      let $gridWrapper = $wrapper.querySelector('.image-features-grid');
      const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: 'unslick'
          }
        ]
      };


      if($cells.length < 2) return;

      function windowResizeCallback() {
        if ($(window).width() > 1200) {
          if($gridWrapper.classList.contains('slick-initialized')) {
            $($gridWrapper).slick('unslick');
          } 
          return;
        } else {
          if(!$gridWrapper.classList.contains('slick-initialized')) {
            return $($gridWrapper).slick(settings)
          }
        }
      }

      $(window).on('load resize', windowResizeCallback);
    }

    [...$wrappers].forEach(setupSlicks);

})();